{
  "register": {
    "card": {
      "title": "Welcome to Starmind",
      "subtitle": "Create an account to get instant access to experts and knowledge!"
    },
    "firstname": {
      "label": "First name"
    },
    "lastname": {
      "label": "Last name"
    },
    "password": {
      "label": "Password",
      "hint": "Password must have at least 8 characters and contain at least one lowercase letter, one uppercase letter and a number."
    },
    "password-confirm": {
      "label": "Confirm password"
    },
    "submit": {
      "button": "Create account"
    },
    "email": {
      "label": "Email"
    },
    "error": {
      "password-mismatch": "Passwords must match"
    }
  },
  "header": {
    "register": {
      "button": "Register",
      "label": "Don’t have an account yet?"
    },
    "auth": {
      "label": "Already have an account?",
      "button": "Log in"
    }
  },
  "authentication": {
    "card": {
      "title": "Sign in"
    },
    "email": {
      "label": "Enter your email address"
    },
    "password": {
      "label": "Enter your password",
      "url": {
        "label": "Forgot your password?"
      }
    },
    "remember-me": "Keep me signed in",
    "submit": {
      "button": "Log in"
    },
    "reset-password": {
      "button": "Forgot password?",
      "label": "Forgot password?",
      "url": {
        "label": "Click here"
      }
    },
    "login": {
      "saml": "Login with {{provider}}"
    },
    "provider": {
      "separator": {
        "label": "or"
      }
    }
  },
  "error": {
    "password": {
      "policy": "Password must have at least 8 characters and contain at least one lowercase letter, one uppercase letter and a number.",
      "invalid": "Wrong user name or password. Please try again.",
      "confirm-mismatch": "Passwords don't match",
      "history": "Password must not be equal to any of your last 4 passwords",
      "blacklist": "Password is not allowed",
      "is-username": "Password must not be equal to the username"
    },
    "email": {
      "invalid": "Please enter a valid email address",
      "exists": "Email address already exists",
      "domain": "Please use your '@{{domain}}' email address, unless you changed it on the platform."
    },
    "field": {
      "required": "Information is required"
    }
  },
  "required-action": {
    "verify-email": {
      "info": "Please verify your email by clicking on the link that has just been sent to your account to finish the registration.",
      "resend-email": {
        "button": "Send again"
      },
      "card": {
        "title": "Verify your email"
      }
    },
    "update-password": {
      "card": {
        "title": "Set password"
      },
      "submit": {
        "button": "Submit"
      }
    }
  },
  "reset-password": {
    "card": {
      "title": "Reset password"
    },
    "submit": {
      "button": "Reset"
    },
    "info": "To reset your password, enter your email address.\nWe will send you a link to set a new password."
  },
  "error-page": {
    "contact": {
      "button": "Contact support"
    },
    "expired": {
      "title": "Your session has expired",
      "message": "Unfortunately your session has expired and we need you to log in again.",
      "button": "Log in"
    },
    "generic": {
      "title": "Looks like something went wrong.\nPlease try again later."
    },
    "back": {
      "button": "Go back"
    },
    "not-found": {
      "title": "The page? It’s gone…",
      "message": "We can’t find what you’re looking for. \nIt's likely that the Starmind UI doesn't support this functionality yet."
    },
    "mail-to-button": {
      "subject": "{{network}} login problem",
      "body": "Dear admin,\n\nWhen trying to access {{url}}, I get an error message saying \"{{error}}\".\nCould you please reactivate my account?"
    }
  },
  "generic-message": {
    "type": {
      "info": "Note: ",
      "success": "Success: ",
      "warning": "Warning: ",
      "error": "Error: "
    }
  },
  "cancel": "Cancel",
  "language": {
    "en": "English",
    "de": "German (Deutsch)",
    "fr": "French (Français)",
    "es": "Spanish (Español)"
  },
  "info-page": {
    "generic": {
      "backButton": "Go back",
      "proceedButton": "Continue"
    }
  },
  "saml-redirect": {
    "card": {
      "title": "You are being redirected to login your account."
    }
  },
  "update-profile": {
    "email": {
      "label": "Email"
    },
    "firstname": {
      "label": "First name"
    },
    "lastname": {
      "label": "Last name"
    },
    "submit": {
      "button": "Submit"
    },
    "card": {
      "title": "Update profile information"
    }
  },
  "link-account": {
    "card": {
      "title": "Account already exists"
    },
    "link": {
      "button": "Send confirmation email"
    },
    "user-exists": {
      "copy": "An account with this email address already exists. To continue, please verify your email address."
    },
    "confirm-email": {
      "copy": "We sent a confirmation link to your email address. Please check your inbox and click on the link in the email.",
      "card": {
        "title": "Verify your email address"
      }
    },
    "resend-email": {
      "button": "Resend email"
    }
  },
  "set-password": {
    "requirements": {
      "label": {
        "first": "At least 8 characters",
        "second": "Include both upper & lowercase letters",
        "third": "Use at least one number"
      }
    }
  },
  "legal-conditions": {
    "label": {
      "first": "By logging in you're agreeing to"
    },
    "link": {
      "user-terms": {
        "label": "User Terms of Use"
      },
      "privacy-policy": {
        "label": "Privacy Policy"
      }
    },
    "and": {
      "label": "and"
    }
  },
  "on-boarding": {
    "sign-in": {
      "screen": {
        "infobar": "Starmind is a platform that connects you with your organization’s best-available knowledge — powered by AI and available in real-time.",
        "title": "Welcome back!"
      }
    }
  },
  "trial-expired": {
    "title": "Your trial has ended",
    "body": "Contact us to continue with Starmind and \nkeep knowledge available to everyone.",
    "cta": "Get in touch"
  },
  "vue": {
    "error": {
      "email": {
        "domain": "Please use your '{'@'}{domain}' email address, unless you changed it on the platform."
      }
    },
    "legal-conditions": {
      "text": "By logging in you're agreeing to {terms} and {privacy}."
    },
    "authentication": {
      "login": {
        "saml": "Login with {provider}"
      }
    },
    "error-page": {
      "mail-to-button": {
        "subject": "{network} login problem",
        "body": "Dear admin,\n\nWhen trying to access {url}, I get an error message saying \"{error}\".\nCould you please reactivate my account?"
      }
    }
  }
}
